import React, { type FC, type MouseEvent, useCallback } from 'react';

import cn from 'classnames';

import type { ToggleProps } from './types';

import styles from './styles.module.scss';

/**
 * Название: Переключатель
 * Параметры:
 * checked: {boolean} - состояние вкл./выкл
 * disabled: {boolean} - возможность изменять состояние
 * onChange: {function} - метод вызываемый при смене состояния
 * text: {string} - текст выводимый возле переключателя. по умолчанию справа
 * isLeftSideText: {boolean} - выводить текст слева
 * boldText: {boolean} - жирный текст
 */
export const Toggle: FC<ToggleProps> = ({
	checked,
	disabled,
	onChange,
	text,
	boldText,
	isLeftSideText,
}) => {
	const handleClick = useCallback(
		(e: MouseEvent<HTMLElement>) => {
			e.preventDefault();
			if (!disabled) {
				onChange(!checked);
			}
		},
		[onChange, disabled, checked]
	);

	return (
		<div className={cn(styles.ToggleWrap, { [styles.LeftText]: isLeftSideText })}>
			<button
				aria-label={text || 'Toggle'}
				aria-pressed={checked}
				type="button"
				className={cn(
					styles.Toggle,
					{ [styles.checked]: checked },
					{ [styles.disabled]: disabled }
				)}
				onClick={handleClick}
			>
				<div className={styles.ToggleIcons}>
					<div className={styles.ToggleIconOn} />
					<div className={styles.ToggleIconOff} />
				</div>
				<div className={styles.ToggleButton} />
			</button>
			{text && (
				<div
					className={cn(styles.ToggleText, { [styles.BoldText]: boldText })}
					onClick={handleClick}
				>
					{text}
				</div>
			)}
		</div>
	);
};
